import React from "react";
import { Card } from "antd";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "600px",
};

const center = {
  lat: -2.548926, // Pusat Indonesia
  lng: 118.0148634,
};

const branchLocations = [
  { lat: -6.2088, lng: 106.8456, name: "Jakarta" }, // Contoh lokasi Jakarta
  { lat: -7.2504, lng: 112.7688, name: "Surabaya" }, // Contoh lokasi Surabaya
  { lat: -6.9175, lng: 107.6191, name: "Bandung" }, // Contoh lokasi Bandung
  { lat: 1.48218, lng: 124.84899, name: "Manado" }, // Contoh lokasi Manado
];

const Cabang = () => {
  return (
    <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
      <div className="col-lg-12">
        {/* Form Input */}
        <Card
          title={
            <h5
              className="text-center"
              style={{
                margin: 5,
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Nearby Drop Point
            </h5>
          }
          bordered={false}
          className="mb-4 shadow-sm"
        >
          Service agent kami siap membantu anda.
        </Card>
      </div>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={5}>
        {branchLocations.map((branch, index) => (
          <Marker
            key={index}
            position={{ lat: branch.lat, lng: branch.lng }}
            title={branch.name}
            icon={{
              url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png", // URL ikon pin
            }}
          />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default Cabang;
